import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { get } from 'lodash';

import IconComponent from '../../../common/IconComponent';
import { CANDIDATE_ICON } from '../../../../constants/IconType';
import ProfileImg from '../../../../assets/image/profile.svg';

const useStyles = makeStyles({
    candidatePhoto: {
        gridArea: 'candidatePhoto',
        width: ({ width }) => width,
        height: ({ height }) => height,
    },
    candidatePlaceholder: {
        gridArea: 'candidatePhoto',
        width: ({ width }) => width,
        height: ({ height }) => height,
        borderRadius: 3,
    },
});

// Modified by AI on 05/26/2026. Edit #1.
const CandidateProfilePhoto = ({
    profile, profileBackground, width = 100, height = 100, photoUrl = '',
}) => {
    const classes = useStyles({ width, height });

    const isPhotoVisible = get(profile, 'systemMetadata.isPhotoVisible', true);
    const photo = get(profile, 'photos.0', photoUrl);

    return isPhotoVisible
        ? <IconComponent
            key={photo}
            className={classes.candidatePhoto}
            url={photo}
            type={CANDIDATE_ICON}
            width={width}
            height={height}
        />
        : <img
            src={ProfileImg}
            className={classes.candidatePlaceholder}
            style={{ background: profileBackground }}/>;
};

CandidateProfilePhoto.propTypes = {
    profile: PropTypes.object,
    profileBackground: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default CandidateProfilePhoto;
